{
    "MakeCallTitle": "Bellen",
    "MakeCallTooltip": "Bel naar het bijbehorende apparaat.",
    "IttTitle": "Aanvraag doorverbinden",
    "IttTooltip": "Maak een ruggespraakgesprek met het betreffende apparaat om een gesprek doorverbinden te starten.",
    "CallDetailsTitle": "CME-details",
    "CallDetailsTooltip": "Gedetailleerde oproepinformatie weergeven in een nieuw venster.",
    "CompleteTransferTitle": "Overdracht voltooien",
    "CompleteTransferTooltip": "Voltooi het eerder gestarte doorverbinden van ruggespraak door het gesprek in de wacht te verplaatsen naar de eerder gebelde doelbestemming.",
    "PickupThisCallTitle": "Welkom bij Redcentric Call Reporting",
    "PickupThisCallTooltip": "Deze waarschuwingsoproep direct op uw eigen toestel beantwoord.",
    "StealThisCallTitle": "Welkom bij Redcentric Call Reporting",
    "StealThisCallTooltip": "Verplaats de momenteel beantwoorde of alarmerende oproep naar uw toestel waar het vervolgens zal overgaan.",
    "SendToCallTitle": "Stuur oproep naar...",
    "SendToCallTooltip": "Verplaats de momenteel beantwoorde of alarmerende oproep naar een specifieke nieuwe bestemming waar deze vervolgens zal overgaan.",
    "MonitorTitle": "Monitor",
    "MonitorTooltip": "Apparaat- en oproepmonitoropties.",
    "SilentMonitorTitle": "Stille monitor",
    "SilentMonitorTooltip": "Start een stille monitorsessie met de momenteel beantwoorde oproep op het apparaat.",
    "ForcedIntrudeTitle": "Gedwongen binnendringen",
    "ForcedIntrudeTooltip": "Inbreken (binnenvallen) in de momenteel beantwoorde oproep op het bijbehorende apparaat, zodat u actief kunt deelnemen aan die oproep.",
    "RecordCallTitle": "Oproep opnemen",
    "RecordCallTooltip": "Voer een live oproepopnamebewerking uit op de momenteel beantwoorde oproep op het apparaat.",
    "RegisterCallbackTitle": "Terugbellen registreren",
    "RegisterCallbackTooltip": "Geef een bericht weer op het corresponderende apparaat en herinner hen eraan om uw specifieke toestel terug te bellen.",
    "AgentSignInOutTitle": "Aan- en afmelden voor agenten",
    "AgentSignInOutTooltip": "Aanmelden\/Afmelden bij extensie.",
    "SignInTitle": "Log in...",
    "SignInTitleAllGroups": "Aanmelden (alle groepen)",
    "SignInTooltip": "Meld het corresponderende apparaat of de corresponderende agent aan, zodat ze 'van dienst' zijn en mogelijk beschikbaar zijn om ACD-oproepen te beantwoorden.",
    "SignOutTitle": "Afmelden",
    "SignOutTitleAllGroups": "Afmelden (alle groepen)",
    "SignOutTooltip": "Meld het corresponderende apparaat of de corresponderende agent af, waardoor ze 'buiten dienst' zijn en niet beschikbaar zijn om ACD-oproepen te beantwoorden.",
    "GroupsTitle": "Groepen",
    "GroupsTooltip": "Behandel dit bericht door deze stappen te volgen:",
    "NoGroupsTooltip": "Er zijn geen ACD-groepen gevonden voor deze agent.",
    "GroupsAllTitle": "[All]",
    "SetDndOnTitle": "Niet storen inschakelen",
    "SetDndOnTooltip": "Schakel 'niet storen' in op het apparaat, waardoor het niet meer kan worden gebeld.",
    "SetDndOffTitle": "Niet storen uitschakelen",
    "SetDndOffTooltip": "Schakel 'niet storen' uit op het apparaat, zodat het beschikbaar is voor het ontvangen van inkomende oproepen.",
    "SetStatusTitle": "Status instellen",
    "SetStatusTooltip": "Stel de ACD-status in voor deze agent.",
    "AvailableTitle": "Verkrijgbaar",
    "AvailableTooltip": "Stel de agent in op de status Beschikbaar, zodat deze beschikbaar is om ACD-oproepen te beantwoorden.",
    "DndTitle": "Niet storen",
    "DndTooltip": "Stel de agent in op de NST-status, waardoor hij niet meer beschikbaar is om ACD-oproepen te beantwoorden.",
    "WrapUpTitle": "Inpakken",
    "WrapUpTooltip": "Zet de agent in de status Afronden, waardoor hij niet meer beschikbaar is om ACD-oproepen te beantwoorden.",
    "NotAvailableTitle": "Niet beschikbaar",
    "NotAvailableTooltip": "Stel de agent in op Niet-beschikbare ACD-status en geef bovendien een redencode op, die kan worden gebruikt om te identificeren waarom de corresponderende agent specifiek niet beschikbaar is om ACD-oproepen te beantwoorden.",
    "NoReasonTitle": "[Geen reden]",
    "NoReasonTooltip": "Stel de agent in op de status Niet beschikbaar ACD en geef geen reden op.",
    "AdvancedTooltip": "Geavanceerde diagnostiek",
    "AnswerCallTitle": "Beantwoord oproep",
    "AnswerCallTooltip": "Welkom bij Redcentric Call Reporting",
    "ClearCallTitle": "Oproep wissen",
    "ClearCallTooltip": "1) Bekijk het bijgevoegde e-mailbestand.",
    "AdminOnlyTitle": "Alleen beheerder",
    "AdminOnlyTooltip": "Alarmacties",
    "DeletePhantomTitle": "Verwijderen",
    "DeletePhantomTooltip": "Forceer de toepassing om te stoppen met het modelleren van de corresponderende oproep als actief, wat een negatief effect kan hebben op de oproepstatistieken.",
    "RowOptions_AdvancedTitle": "Geavanceerd",
    "NAME": "RowOptions",
    "SetAccountCodeMenuOptionTitle": "Accountcode instellen",
    "SetAccountCodeMenuOptionTooltip": "Accountcode voor deze oproep instellen.",
    "NoAccountCodeMenuOptionTitle": "[Geen rekeningcode]",
    "NoAccountCodeMenuOptionTooltip": "De accountcode verwijderen",
    "AccountCodeMenuOptionTooltip": "Stel accountcode '{}' in voor de oproep."
}